import React from "react";
import classNames from "classnames";
import { BemHelper } from "../../utils/BemHelper";
import { Button } from "../../publish/button";
import { PlayIcon } from "@/icons/primary";

const bem = new BemHelper("tutorial-banner");

type Props = {
  Tip: React.ReactNode;
  link: string;
};

export const TutorialBanner: React.FC<Props> = ({ Tip, link }) => {
  return (
    <div className={classNames(bem.block())}>
      <div className={classNames(bem.element("tip"))}>💡 {Tip}</div>
      {link && (
        <Button
          type='secondary'
          shape='round'
          style={{
            background: "transparent",
            color: "white",
            borderColor: "white",
          }}
          leftIcon={<PlayIcon style={{ fontSize: "25px" }} />}
          href={link}
        >
          View Tutorial
        </Button>
      )}
    </div>
  );
};
